document.addEventListener('DOMContentLoaded', function () {

    gsap.registerPlugin(ScrollTrigger);

    /* ----- LENIS ----- */

    const lenis = new Lenis({ smooth: true });
    window.themeLenis = lenis;

    //sync scroll trigger animations
    lenis.on("scroll", ScrollTrigger.update);

    // ScrollTrigger must read/write scroll position through Lenis, not the browser.
    // Without this, pinned sections drift and release at the wrong scroll offset.
    ScrollTrigger.scrollerProxy(document.documentElement, {
        scrollTop(value) {
            if (arguments.length) {
                lenis.scrollTo(value, { immediate: true });
            }
            return lenis.scroll;
        },
        getBoundingClientRect() {
            return {
                top: 0,
                left: 0,
                width: window.innerWidth,
                height: window.innerHeight,
            };
        },
    });

    ScrollTrigger.addEventListener('refresh', () => {
        lenis.resize();
    });

    //make sure the animations are driven by gsap internal clock and not the browser defaults
    gsap.ticker.add((time) => {
        lenis.raf(time * 1000); 
    });
    
    //disable lag smoothing for more responsive scrolling without jumpings
    gsap.ticker.lagSmoothing(0);

    window.dispatchEvent(new CustomEvent('theme:scroll-ready'));

    // Pause Lenis while theme dialogs/drawers are open so nested scroll works.
    document.addEventListener(
      'dialog:open',
      () => {
        lenis.stop();
      },
      true
    );

    document.addEventListener(
      'dialog:close',
      () => {
        lenis.start();
      },
      true
    );

    /* ---------------- */


});